import React, {useEffect, useState, useRef} from 'react'
import firebase from '../../firebase/config'
import {Link} from 'react-router-dom';
import moment from 'moment';
// import ModalGuide from '../../components/ModalGuide';
import utils from '../../firebase/utils';
import Compress from "react-image-file-resizer";
import {useLocation} from 'react-router-dom';
import { debounce } from '../../utils/debounce';
import { DatePickerCalendar , useDateInput, Calendar, DatePicker } from 'react-nice-dates'
import { es } from 'date-fns/locale'

function UploadCombo() {

    let todayDate = moment().format("YYYY-MM-DD")
    let minDate = moment().format("YYYY-MM-DD")
    const [limitDate, setLimitDate] = useState(todayDate)

    function formatDate(d){
        let n = moment(d).format("DD/MM/YYYY")
        setLimitDate(n)
    }

    const [productsTypes, setProductsTypes] = useState([])
    const [palabrasClave, setPalabrasClave] = useState([])
    const [localidades, setLocalidades] = useState([])
    const [species, setSpecies] = useState([])
    const [razas, setRazas] = useState([])
    const [listErrors, setListErrors] = useState([])
    const [comboItems, setComboItems] = useState([])
    const [services, setServices] = useState([])
    const [products, setProducts] = useState([])
    const [dataList, setDataList] = useState([])
    const [dataListNew, setDataListNew] = useState([])
    
    const [promoCode, setPromoCode] = useState("");
    const [titleValue, setTitleValue] = useState("");
    const [successMsg, setSuccessMsg] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [palabra, setPalabra] = useState("")
    const [localidadId, setLocalidad] = useState("")
    const [soles, setSoles] = useState(0)
    const [btnMessage, setBtnMessage] = useState("Subir combo");

    const [countryInfo, setCountryInfo] = useState({})
    const [user, setUser] = useState({})

    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [finalClientStatus, setFinalClientStatus] = useState(true);
    const [aliadoClientStatus, setAliadoClientStatus] = useState(false);
    const [petPointsStatus, setPetPointsStatus] = useState(false);
    const [showCalendar, setShowCalendar] = useState(true);
    const [showProdServModal, setShowProdServModal] = useState(false);

    const inputTag = useRef(null)
    const inputSku = useRef(null)
    const inputName = useRef(null)
    const inputDesc = useRef(null)
    const inputWord = useRef(null)
    const inputPeso = useRef(null)
    const inputPrice = useRef(null)
    const inputCantidad = useRef(null)
    const inputMinima = useRef(null)
    const hiddenFileInput = useRef(null);

    let errorInputMsg = "Campo requerido"

    const [comboInfo, setComboInfo] = useState({
        status: "",
        titulo: "",
        descripcion: "",
        dirigido: "Selección",
        edad: "",
        tipoMascota: "Selección",
    })
    
    const [comboItemInfo, setComboItemInfo] = useState({
        tipo: "",
        id: "",
        localidadId: "",
        precio: 0,
        desc: 0,
        data: "",
        precioDesc: 0,
    })

    const [file, setFile] = useState(null);
    const [url, setURL] = useState("");
    const [src, setImg] = useState('');

    const handleClick = event => {
        hiddenFileInput.current.click();
    };

    async function handleChange(e) {
        var file = e.target.files[0]
        Compress.imageFileResizer(
          file,
          600,
          300,
          "JPEG",
          10,
          0,
          (uri) => {
            setFile(uri)
            console.log(uri)
          },
          "file",
          600,
          300
        )
        setImg(URL.createObjectURL(file))
        setListErrors(listErrors.filter( prev => prev !== "img" ))
    }

    const getServices = async(id) =>{
        let tipos = [];
        let tipos2 = [];

        await firebase.db.collection("Localidades").where("aliadoId", "==", id).get().then(val => {
            val.docs.forEach(item => {
                tipos.push(item.data())
            })
        })

        Promise.all(tipos.map(async (doc) => {
            firebase.db.collection("Localidades").doc(doc.localidadId).collection("Servicios").get().then(val => {
                val.docs.forEach(item => {
                    let o1 = {
                        titulo: item.data().titulo,
                        img: item.data().urlImagen,
                        precio: item.data().precio,
                        tipo: "",
                        id: item.data().servicioId,
                        tipoItem: "Servicio",
                        nombreLocalidad: doc.nombreLocalidad,
                        localidadId: doc.localidadId,
                    }
                    tipos2.push(o1)
                })
            })

        }))

        let allList = tipos2

        setTimeout(() => {
            setServices(allList)
        }, 500);
  
    }
    
    const getProductos = async(id) =>{
        let tipos = [];

        await firebase.db.collection("Productos").where("aliadoId", "==", id).get().then(val => {
            val.docs.forEach(item => {
                let o1 = {
                    titulo: item.data().titulo,
                    precio: item.data().precio,
                    img: item.data().urlImagen,
                    tipo: "",
                    id: item.data().productoId,
                    tipoItem: "Producto",
                    nombreLocalidad: item.data().categoria,
                    localidadId: "",
                }
                tipos.push(o1)
            })
        })

        setTimeout(() => {
            setProducts(tipos)
        }, 500);
  
    }

    const getData = (t) =>{
        t === "Servicio" && setDataList(services)
        t === "Producto" && setDataList(products)
    }

    function createDescPrice(p){
        let d = parseInt(comboItemInfo.data["precio"])*p/100
        setComboItemInfo({
            ...comboItemInfo,
            desc: parseFloat(comboItemInfo.data["precio"]) - parseFloat(d)
        })
    }

    function createItem(){
        let tipos = [...comboItems]
        tipos.push(comboItemInfo)

        setComboItems(tipos)
    }

    const getRazas = async(tipoM) =>{
        let tipos = [];
        await firebase.db.collection('Especies').doc(tipoM).collection("Razas").get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.id)
                tipos.sort()
            })
            setRazas(tipos)
        })
    }

    const getPets = async() =>{
        let tipos = [];
        await firebase.db.collection('Especies').get().then(val => {
            val.docs.forEach(item=>{
                tipos.push(item.id)
                tipos.sort()
            })
            setSpecies(tipos)
        })
    }

    const handleKeyPress = (event) => {
        if(event.key === 'Enter' && palabra !== ""){
            setPalabrasClave([...palabrasClave, palabra])
            inputTag.current.value = ""
        }
    }

    const SuccessComponent = ({msg}) => {
        return (
            <div className="success-alert">
                <span className="material-icons mr-2">done</span>
                {msg}
                <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
            </div>
        )
    }

    const ErrorComponent = ({msg}) => {
      return (
          <div className="error-alert">
              <span className="material-icons mr-2">error</span>
              {msg}
              <div onClick={()=>{setError(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    function checkInputs(o){
        let val = 0
        let array = []
        o["img"] = src
        Object.keys(o).forEach(function(key) {
            if(key.toString() !== "continuarVendiendo"){
                if (o[key] === '' || o[key] <= 0) {
                    val++
                    array.push(key)
                }
            }
        });
        if(val > 0){
            setListErrors(array)
            window.scrollTo(0, 0)
        }else{
            setListErrors([])
            uploadCombo()
            console.log("Todo bien")
        }
    }
        
    async function getValuePetPoint(pais){
        try {
            await firebase.db.collection("Ciudades").doc(pais).get().then((v)=>{
                let precioPP =  parseInt(v.data().valorPunto)
                setSoles(precioPP)
            })
        }catch(e){

        }
    }

    const [prevScrollPos, setPrevScrollPos] = useState(0);
    const [visible, setVisible] = useState(true);
  
    const handleScroll = debounce(() => {
      const currentScrollPos = window.pageYOffset;
  
      setVisible((prevScrollPos > currentScrollPos && prevScrollPos - currentScrollPos > 70) || currentScrollPos < 10);
  
      setPrevScrollPos(currentScrollPos);
    }, 100);
  
    useEffect(() => {
      window.addEventListener('scroll', handleScroll);
  
      return () => window.removeEventListener('scroll', handleScroll);
  
    }, [prevScrollPos, visible, handleScroll]);
  
    const navbarStyles = {
      position: 'fixed',
      height: '65px',
      width: '83.3%',
      backgroundColor: 'white',
      zIndex: "11",
      textAlign: 'center',
      transition: 'top 0.6s',
      padding: "1% 2%",
      right: "0px",
      boxShadow: "0 0.125rem 0.625rem rgb(90 97 105 / 12%)"
    }

    function selectDataFromList(palabra){
        let tipos = []
        if(palabra !== ""){
            for(let i = 0; i < dataList.length; i++){
                let w = dataList[i]["titulo"]
                if(w.toLowerCase().includes(palabra.toLowerCase())){
                    tipos.push(dataList[i])
                }else{
                    setDataListNew([])
                    setTitleValue(palabra)
                }
            }
            setDataListNew(tipos)
        }else{
          setTitleValue("")
          setDataListNew([])
        }
    }

    function makeid(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var charactersLength = characters.length;
        for ( var i = 0; i < length; i++ ) {
          result += characters.charAt(Math.floor(Math.random() * 
     charactersLength));
       }
       return result;
    }

    useEffect(() => {
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          getServices(val.aliadoId)
          getProductos(val.aliadoId)
          getValuePetPoint(val.pais)
          firebase.getCountryInfo(val.pais).then(async (val) => {
            setCountryInfo(val.data()) 
          })
        });
        setPromoCode(makeid(6))
        getPets()

    }, [])

    return (
        <div className="main-content-container container-fluid px-4">
            {error && <ErrorComponent msg={errorMsg === "" ? "Todos los campos son requeridos" : errorMsg}/>}
            {success && <SuccessComponent msg={successMsg === "" ? "Promoción cargada exitosamente" : successMsg}/>}

            <div style={{ ...navbarStyles, top: visible ? '-60px' : '60px' }}>
                <div className="row no-gutters align-items-center justify-content-spacebetween mb-4">
                    <h4 className="color-primary bold mb-0">Crear combo</h4>
                    <div className="row no-gutters">
                        <div onClick={()=>{ checkInputs(comboInfo) }} className="btn btn-success">Crear combo</div>
                    </div>
                </div>
            </div>

            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
                <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                    <div className="row align-items-center">
                        <div className="col">
                            <p className="page-title bold"><Link className="color-white light" to="/combos">Combos</Link> <span>Nuevo</span> </p>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-sm-1 mb-0 level-1">
                    <div className="row align-items-center justify-content-space-around level-2">
                        <i onClick={()=>{}} className="material-icons color-white display-5 cursor-pointer">help_outline</i>
                    </div>
                </div>
            </div>

            <div className="row no-gutters">
                <div className="col-lg-8">
                    
                    <div className="row no-gutters align-items-center justify-content-spacebetween mb-4">
                        <h4 className="color-primary bold mb-0">Crear combo</h4>
                        <div className="row no-gutters">
                            <div  onClick={()=>{ checkInputs(comboInfo) }} className="btn btn-success">Crear combo</div>
                        </div>
                    </div>

                    <div className="creation-card mb-3">
                        <div className="creation-card-title">Detalles</div>
                        <div className="creation-card-content">
                            
                            <div className="creation-input-group mb-3 no-gutters">
                                <div className="col-lg-7">
                                    <p className="creation-input-label">Código del combo</p>
                                </div>
                                <div className="col-lg-5">
                                    <input value={promoCode} onChange={(e)=>{setPromoCode(e.target.value); }} className={`form-control col-lg-12`} />
                                </div>
                            </div>

                            <div className="creation-input-group mb-3 no-gutters">
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Estado</p>
                                </div>
                                <div className="col-lg-8">
                                    <select value={comboInfo.status} onChange={(e)=>{setComboInfo({...comboInfo, status: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "status" ) )  }} 
                                    className={`form-control col-lg-12 ${ listErrors.includes("status") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="Activo">Activo</option>
                                        <option value="Borrador">Borrador</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("status") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group-words">

                                <div className="creation-input-group no-gutters mr-2" style={{width: "100%"}}>
                                    <div className="col-lg-5">
                                        <p className="creation-input-label">Etiquetas</p>
                                    </div>
                                    <div className="col-lg-7">
                                        <input ref={inputTag} type="text" onKeyPress={handleKeyPress} onChange={e=>{setPalabra(e.target.value)}}  placeholder="Comida" className="form-control"/>
                                    </div>
                                </div>
                                {palabrasClave.map(p => (
                                    <p className="pill mb-0" key={p}>{p} <span className="cursor-pointer btn-delete" onClick={()=>{ setPalabrasClave(palabrasClave.filter((p1) => p1 !== p)); }} >X</span></p>
                                ))}

                            </div>



                        </div>
                    </div>

                    <div className="creation-card mb-3">
                        <div className="creation-card-title mb-2">Mercado</div>
                        <p className="creation-card-p">Indica a quien está dirigida el combo</p>
                        <div className="creation-card-content">
                            
                            <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Edad</p>
                                </div>
                                <div className="col-lg-8">
                                    <select value={comboInfo.edad} onChange={(e)=>{setComboInfo({...comboInfo, edad: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "edad" ) )  }} className={`form-control col-lg-12 ${ listErrors.includes("edad") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                        <option value="Cachorro">Cachorro</option>
                                        <option value="Sénior">Sénior</option>
                                        <option value="Adulto">Adulto</option>
                                        <option value="Todos">Todos</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("edad") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Especie</p>
                                </div>
                                <div className="col-lg-8">
                                    <select value={comboInfo.tipoMascota} onChange={(e)=>{setComboInfo({...comboInfo, tipoMascota: e.target.value}); getRazas(e.target.value); setListErrors(listErrors.filter( prev => prev !== "tipoMascota" ) )    }} className={`form-control col-lg-12 ${ listErrors.includes("tipoMascota") && "border-danger" } `}>
                                        <option value="">Selección</option>
                                            {species.map(data => (
                                                <option key={data} value={data}>{data}</option>
                                            ))}
                                        <option value="Todos">Todos</option>
                                    </select>
                                </div>
                                <div className="creation-errors-container">
                                    {listErrors.includes("tipoMascota") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            { razas.length > 0 && <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                <div className="col-lg-3">
                                    <p className="creation-input-label">Raza</p>
                                </div>
                                <div className="col-lg-8">
                                    <select value={comboInfo.dirigido} onChange={(e)=>{setComboInfo({...comboInfo, dirigido: e.target.value})}} className={`form-control col-lg-12`}>
                                        <option value="">Selección</option>
                                        {razas.map((data, i) => (
                                            <option key={i} value={data}>{data}</option>
                                        ))}
                                    </select>
                                </div>
                            </div> }

                        </div>
                    </div>

                    <div className="creation-card mb-3">
                        <div className="creation-card-title">Precio</div>
                        <div className="creation-card-content">

                            <div className="creation-input-group no-gutters mb-4" style={{width: "30%"}}>
                                <div className="col-lg-5">
                                    <p className="creation-input-label">Precio</p>
                                </div>
                                <div className="col-lg-5">
                                    <input type="number" min="0" value={comboInfo.precio} onChange={(e)=>{setComboInfo({...comboInfo, precio: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "precio" ) )  }} placeholder="0" className={`form-control col-lg-12 ${ listErrors.includes("precio") && "border-danger" } `}/>
                                </div>
                                <div className="creation-errors-container">
                                    {(listErrors.includes("precio") && finalClientStatus) && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                        </div>
                    </div>
                   
                    <div className="creation-card mb-3">
                        <div className="creation-card-title mb-2">Creación de los items</div>
                        <div className="creation-card-content">
                            
                            <div className="creation-input-group no-gutters" style={{width: "20%"}}>
                                <div className="col-lg-12">
                                    <select value={comboItemInfo.tipo} onChange={(e)=>{ setComboItemInfo({...comboItemInfo, tipo: e.target.value}); getData(e.target.value) }} className={`form-control col-lg-12`}>
                                        <option value="">Categoría</option>
                                        <option value="Producto">Producto</option>
                                        <option value="Servicio">Servicio</option>
                                    </select>
                                </div>
                            </div>
                            
                            { dataList.length > 0 && <div className="creation-input-group no-gutters" style={{width: "20%"}}>
                                <div className="col-lg-12">
                                    
                                    <div className="col-lg-12 custom-dropdown">
                                      <input placeholder="Selección" value={titleValue} onChange={(e)=>{ selectDataFromList(e.target.value) }} className="form-control"/>
                                      <div className="custom-dropdown-box" style={{width: "230px"}} >
                                        {dataListNew.map((val, i)=>{
                                            return (
                                            <div className="custom-dropdown-option cursor-pointer" onClick={()=>{ setComboItemInfo({...comboItemInfo, data: val});  setDataListNew([]); setTitleValue(val.titulo) } } key={i}>
                                                <img src={val.img} className="custom-dropdown-option-img"/> 
                                                {val.titulo}
                                            </div>
                                            )
                                        })}
                                      </div>
                                    </div>

                                </div>
                            </div> }
                            
                            <div className="creation-input-group no-gutters" style={{width: "5%"}}>
                                <div className="col-lg-12 position-relative">
                                    <span className="creation-input-group-span">Precio</span>
                                    <p className="creation-input-label">{countryInfo ? countryInfo.simbolo : ""}{comboItemInfo.data === "" ? "0" :comboItemInfo.data["precio"]}</p>
                                </div>
                            </div>
                            
                            <div className="creation-input-group no-gutters" style={{width: "10%"}}>
                                <div className="col-lg-12 position-relative">
                                    <span className="creation-input-group-span" style={{bottom: "35px"}}>Descuento</span>
                                    <input placeholder='Descuento' type="number" onChange={(e)=>{ createDescPrice(e.target.value) }} className={`form-control col-lg-12`} />
                                </div>
                            </div>

                            <div className="creation-input-group no-gutters" style={{width: "5%"}}>
                                <div className="col-lg-12 position-relative">
                                    <span className="creation-input-group-span">Descuento aplicado</span>
                                    <p className="creation-input-label">{countryInfo ? countryInfo.simbolo : ""}{comboItemInfo.desc}</p>
                                </div>
                            </div>
                            
                            <div className={`btn ${comboItemInfo.data === "" ? "btn-disabled" : "btn-primary"} `} onClick={()=>{ comboItemInfo.data === "" ? console.log("") : createItem() }} style={{width: "17%"}}>Crear</div>

                            {/* Combo items */}
                            <div className="mt-3" style={{width: "100%"}}>
                                {comboItems.map((item, i)=>{
                                    return(
                                        <div key={i} className="promotion-list-card mb-3">
                                            <div className="promotion-list-title" style={{width: "23%"}}>
                                                <p className="creation-input-label">{item.tipo}</p>
                                            </div>
                                            <div className="promotion-list-title" style={{width: "23%"}}>
                                                <p className="creation-input-label">{item.data["titulo"]}</p>
                                            </div>
                                            <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                                <p className="creation-input-label">{countryInfo ? countryInfo.simbolo : ""}{item.data["precio"]}</p>
                                            </div>
                                            <div className="creation-input-group no-gutters" style={{width: "25%"}}>
                                                <p className="creation-input-label">{countryInfo ? countryInfo.simbolo : ""}{item.desc}</p>
                                            </div>
                                            <div className="creation-input-group no-gutters" style={{width: "15%"}}>
                                                <div className="btn btn-danger" onClick={()=>{ setComboItems( comboItems.filter(prv=>(prv !== item)) ) }} >X</div>
                                            </div>
                                        </div>
                                    )
                                })}

                            </div>
                            {/* End combo items*/}

                        </div>
                    </div>

                </div>
                <div className="col-lg-4 pl-4">
                    
                    <div className="creation-card mb-5 p-3">
                        <div className="creation-card-content">
                            <div className="position-relative">
                                <input type="file" ref={hiddenFileInput} onChange={handleChange}  style={{display: 'none'}} />
                                <div onClick={handleClick} className={`creation-input-photo ${ listErrors.includes("img") && "border-danger" }`}>
                                {src !== "" ? <img src={src} alt="" /> : <div className={`creation-input-photo-inside`}><p className="material-icons icon mb-0">image</p></div>}
                                </div>
                                <div style={{textAlign: "center", width: "100%"}}>
                                    <p style={{fontSize: "13px", color: "#a3a6af"}} className="my-3">Dimensiones recomendadas (200 x 300)</p>
                                </div>
                            </div>
                            
                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Titulo</p>
                                </div>
                                <div className="col-lg-12">
                                    <input value={comboInfo.titulo} onChange={(e)=>{setComboInfo({...comboInfo, titulo: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "titulo" ) )  }} placeholder="Título del combo" className={`form-control col-lg-12 ${ listErrors.includes("titulo") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("titulo") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>

                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Descripción</p>
                                </div>
                                <div className="col-lg-12">
                                    <textarea value={comboInfo.descripcion} onChange={(e)=>{setComboInfo({...comboInfo, descripcion: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "descripcion" ) )  }} placeholder="Descripción del combo" className={`form-control col-lg-12 ${ listErrors.includes("descripcion") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("descripcion") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                            <div className="creation-input-group-grid no-gutters mb-3">
                                <div className="col-lg-12">
                                    <p className="creation-input-label mb-2">Condiciones</p>
                                </div>
                                <div className="col-lg-12">
                                    <textarea value={comboInfo.condiciones} onChange={(e)=>{setComboInfo({...comboInfo, condiciones: e.target.value}); setListErrors(listErrors.filter( prev => prev !== "condiciones" ) )  }} placeholder="Condiciones de la combo" className={`form-control col-lg-12 ${ listErrors.includes("condiciones") && "border-danger" } `}/>
                                </div>
                                 <div className="creation-errors-container">
                                    {listErrors.includes("condiciones") && <p className="creation-errors-span"><i className="material-icons">highlight_off</i> { errorInputMsg } </p>}
                                </div>
                            </div>
                            
                        </div>
                    </div>

                </div>
            </div>

        </div>
    )

    function formatItems(){
        let tipos = []

        for (let i = 0; i < comboItems.length; i++) {
            const objCombo = comboItems[i];
            let obj = {
                tipo: objCombo["tipo"],
                id: objCombo["data"]["id"],
                localidadId: objCombo["data"]["localidadId"],
                precio: objCombo["desc"],
            }

            tipos.push(obj)
            
        }

        return tipos
    }

    async function uploadCombo() {

        let formatedItems = formatItems()

        setBtnMessage("Subiendo...")
        let id = firebase.db.collection("Combos").doc().id;
        try {
            await firebase.storage.ref(`/Combos imagenes/${file.name}`).put(file)
            await firebase.storage.ref("Combos imagenes").child(file.name).getDownloadURL().then((url) => {
                firebase.db.collection("Combos").doc(id).set({
                    aliadoId: user.aliadoId,
                    isApproved: false,
                    status: comboInfo.status,
                    comboId: id,
                    urlImagen: url,
                    localidadId: localidadId,
                    pais: user.pais,
                    titulo: comboInfo.titulo,
                    precio: comboInfo.precio,
                    edad: comboInfo.edad,
                    descripcion: comboInfo.descripcion,
                    tipoMascota: comboInfo.tipoMascota,
                    dirigido: comboInfo.dirigido,
                    palabrasClave: palabrasClave,
                    items: formatedItems,
                    createdOn: moment().toDate(),
                })
            })

            setSuccess(true)
            setSuccessMsg("Combo cargado exitosamente")
            setTimeout(() => {
                setSuccess(false)
                window.location.href = "/combos"
            }, 4000);
            setBtnMessage("Subir combo")
            window.scrollTo(0, 0)
        } catch (error) {
            alert("Ha ocurrido un error: ", error)
        }

    }

}

export default UploadCombo
